import {
  InputCheckboxGroup,
  InputCheckbox,
  InputTextField
} from '@abbott-components/core';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import Stack from '@mui/material/Stack';
import ControlState from '../../Shared/controlState';
import formatName from '../formatName';
import { useContext } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import SizingSelect from '../../Shared/SizingSelect';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);

  const { isReadOnlyView } = state;

  const { schema } = control;

  const properties = schema?.properties as JSONSchema7Properties;

  return (
    <Stack direction="column" spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flexGrow: 1 }}>
          <InputTextField
            name={formatName(properties['consent']?.$id as string)}
            label="Consent"
            isDisabled={isReadOnlyView}
          />
        </Stack>
        <Stack sx={{ flexGrow: 1 }}>
          <InputTextField
            name={formatName(properties['id']?.$id as string)}
            label="ID"
            isDisabled={isReadOnlyView}
          />
        </Stack>
        <SizingSelect
          isReadOnlyView={isReadOnlyView}
          name={formatName(properties['gridSize']?.$id as string)}
        />
      </Stack>
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flexGrow: 1 }}>
          <InputCheckboxGroup
            name={`${formatName(
              properties['required']?.$id as string
            )}-inputCheckBoxGroup`}
            isDisabled={isReadOnlyView}
          >
            <InputCheckbox
              name={formatName(properties['required']?.$id as string)}
              defaultChecked={
                (properties['required'].default as boolean) ?? false
              }
            >
              Required Field
            </InputCheckbox>
          </InputCheckboxGroup>
        </Stack>
      </Stack>
    </Stack>
  );
};
